<template>
  <div class="page-wrapper">
    <div class="container-fluid px-0 py-0">
      <div class="main-card shadow-sm">

        <div class="card-header-custom border-bottom d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div class="d-flex align-items-center gap-3">
            <button class="btn btn-link text-decoration-none p-0 me-1" @click="goBack" title="Volver a convenciones">
              <i class="bi bi-arrow-left-circle-fill fs-4 text-primary"></i>
            </button>
            <h1 class="h4 mb-0 fw-bold text-dark">
              Jornadas de <span class="text-primary">{{ convention?.name || "-" }}</span>
            </h1>
            <span class="badge bg-light text-dark border shadow-sm">
              <i class="fas fa-database text-primary me-1"></i> {{ conferences.length }}
            </span>
          </div>
          <div class="d-flex gap-2">
            <button @click="modalNew" class="btn btn-primary btn-sm shadow-sm d-flex align-items-center">
              <i class="fas fa-plus-circle me-2"></i> Nueva Jornada
            </button>
          </div>
        </div>

        <div class="card-body p-0">

          <div v-if="conferences.length === 0" class="text-center py-5">
            <div class="text-secondary mb-3"><i class="fas fa-calendar-times fa-3x opacity-50"></i></div>
            <p class="text-muted">No se encontraron jornadas registradas.</p>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead class="bg-light text-secondary text-uppercase small">
                <tr>
                  <th class="ps-4 py-3 border-0">Nombre</th>
                  <th class="py-3 border-0">Hora Inicio</th>
                  <th class="py-3 border-0">Hora Fin</th>
                  <th class="py-3 border-0">Descripción</th>
                  <th class="py-3 border-0 text-center">Estado</th>
                  <th class="py-3 border-0 text-center">Participantes</th>
                  <th class="py-3 border-0 text-center">Asistencia</th>
                  <th class="py-3 border-0 text-center" style="white-space: nowrap;">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="conference in conferences" :key="conference.id">
                 
                  <td class="ps-4 py-3">
                    <span class="fw-bold text-dark">{{ conference.name }}</span>
                  </td>
                  <td class="py-3">
                    <span class="badge bg-light text-dark border shadow-sm">
                      {{ formatTime(conference.start_time) }}
                    </span>
                  </td>
                  <td class="py-3">
                    <span class="badge bg-light text-dark border shadow-sm">
                      {{ formatTime(conference.end_time) }}
                    </span>
                  </td>
                  <td class="py-3 text-secondary" style="max-width: 300px">
                    <div class="text-truncate small">
                      {{ conference.description || "Sin descripción" }}
                    </div>
                  </td>
                  <td class="py-3 text-center">
                    <span class="badge" :class="conference.status === 1 ? 'bg-success' : 'bg-danger'">
                      {{ conference.status === 1 ? "Activo" : "Inactivo" }}
                    </span>
                  </td>
                  <td class="py-3 text-center">
                    <span class="badge rounded-pill bg-info bg-opacity-25 text-info fs-6"
                      :title="`${conference.participants_count} participantes registrados`">
                      {{ conference.participants_count }}
                    </span>
                  </td>
                  <td class="py-3 text-center">
               
                    <div class="d-flex flex-column align-items-center gap-1">
                      <span class="badge rounded-pill bg-success bg-opacity-25 text-success fs-6"
                        :title="`${conference.attended_count || 0} participantes asistieron`">
                        <i class="bi bi-check-circle me-1"></i>
                        {{ conference.attended_count || 0 }}
                      </span>
                      <!--asistencia /  la cantidad de inscriptos, no sobre el cupo de la jornada-->
                      <small class="text-muted">{{ Math.floor(conference.attended_count / conference.participants_count * 100 * 100) / 100 || 0 }}%</small>
                    </div>
                  </td>
                  <td class="py-3 text-center">
                    <div class="d-flex gap-2 justify-content-center">
                      <button class="btn btn-sm btn-icon btn-hover-light" @click="showParticipants(conference)"
                        title="Ver inscriptos">
                        <i class="bi bi-people-fill text-primary fs-5"></i>
                      </button>
                      <button class="btn btn-sm btn-icon btn-hover-light" @click="handleExport(conference)"
                        title="Exportar participantes" :disabled="conference.participants_count === 0">
                        <i class="bi bi-download text-success fs-5"></i>
                      </button>
                      <button class="btn btn-sm btn-icon btn-hover-light" @click="editConference(conference)"
                        title="Editar jornada">
                        <i class="bi bi-pencil-fill text-warning fs-5"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <ParticipantsModal
      :participants="selectedParticipants"
      :conference-id="selectedConferenceId"
      :show="showParticipantsModal"
      @close="handleModalClose"
      @attendance-updated="handleAttendanceUpdate"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import ParticipantsModal from "./components/ParticipantsModal.vue";
import { useExporter } from "@/composables/useExporter";
import { useRouter, useRoute } from "vue-router";
import conferenceService from "@/services/api/conference";
import conventionService from "@/services/api/convention";
import Swal from "sweetalert2";

const router = useRouter();
const route = useRoute();

const selectedParticipants = ref([]);
const showParticipantsModal = ref(false);
const selectedConferenceId = ref(null);

const { handleExport: exportData } = useExporter();

const conferences = ref([]);
const convention = ref(null);

const fetchConferences = async () => {
  try {
    console.log("ID de convención usado:", route.params.id);
    const response = await conferenceService.getByConvention(route.params.id);
    console.log("Respuesta de la API:", response.data);
    // Asegúrate de que la estructura de datos sea correcta
    if (response.data && response.data.data) {
      conferences.value = Array.isArray(response.data.data)
        ? response.data.data
        : [];
    } else {
      conferences.value = [];
    }
    console.log("Conferences asignadas:", conferences.value);
  } catch (error) {
    console.error("Error al cargar jornadas:", error);
    conferences.value = [];
  }
};

const fetchConvention = async () => {
  try {
    const response = await conventionService.getConvention(route.params.id);
    convention.value = response.data.data;
  } catch (error) {
    console.error("Error al cargar convención:", error);
  }
};

onMounted(async () => {
  await fetchConvention();
  await fetchConferences();
});
watch(
  () => route.fullPath,
  async () => {
    await fetchConvention();
    await fetchConferences();
  },
);

const goBack = () => {
  router.push({ name: "Convention" });
};

const modalNew = () => {
  const conventionId = route.params.id;
  router.push({ name: "ConferenceForm", params: { id: conventionId } });
};

const formatTime = (timeString) => {
  if (!timeString) return "--:--";
  return timeString.slice(0, 5);
};

const showParticipants = async (conference) => {
  try {
    selectedConferenceId.value = conference.id;

    const response = await conferenceService.getConferenceParticipants(
      conference.id,
    );

    selectedParticipants.value = response.data.data;

    if (selectedParticipants.value.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Sin inscriptos",
        text: "Esta jornada no tiene participantes registrados",
        confirmButtonColor: "#3085d6",
      });
      showParticipantsModal.value = false;
    } else {
      showParticipantsModal.value = true;
    }
  } catch (error) {
    console.error("Error obteniendo participantes:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudieron cargar los participantes",
      confirmButtonColor: "#d33",
    });
  }
};

const handleExport = async (conference) => {
  if (conference.participants_count === 0) {
    Swal.fire({
      icon: "info",
      title: "Sin participantes",
      text: "No hay datos para exportar",
      confirmButtonColor: "#3085d6",
    });
    return;
  }

  try {
    await exportData(
      () => conferenceService.exportConferenceParticipants(conference.id),
      `participantes-${conference.name}.csv`,
    );
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error en la exportación",
      text: "No se pudo generar el archivo de exportación",
      confirmButtonColor: "#d33",
    });
  }
};

const editConference = (conference) => {
  const conventionId = route.params.id;
  router.push({
    name: "ConferenceEditForm",
    params: { id: conventionId, conferenceId: conference.id },
  });
};

const handleAttendanceUpdate = (attendanceData) => {
  console.log("Attendance updated:", attendanceData);
  fetchConferences();
};

const handleModalClose = () => {
  showParticipantsModal.value = false;
  fetchConferences();
};
</script>

<style scoped>
.page-wrapper {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.main-card {
  background: white;
  border-radius: 0.75rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header-custom {
  padding: 1.5rem 2rem;
  background-color: white;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.btn-hover-light:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .card-header-custom {
    padding: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
